import styled from "styled-components";
import { Column } from "uikit";

import { Colors } from "../../../../../../common";

const Root = styled(Column)`
	grid-area: info;

	justify-content: center;

	padding: 8px 12px;

	background: ${Colors.BACKGROUND_GRAY_2};

	box-shadow: 0px -3px 8px 0px #21333f1a;

	z-index: 1;
	min-height: 137px;
	overflow: hidden;
`;

export default Root;
